import { ICustomLookupColumn, ICustomLookupOptions } from '../constants';
import { DEFAULT_SEARCH_SCREEN_DIALOG_STYLE } from './customLookupDefaults.contants';
export const LOOKUP_COLUMNS: ICustomLookupColumn[] = [
  {
    dataField: 'InvoiceNumber',
    caption: 'Invoice',
    allowResizing: true,
    minWidth: 100,
    width: 100,
    fixed: true,
  },
  {
    dataField: 'SalesEntity',
    caption: 'Entity',
    allowResizing: true,
    minWidth: 100,
    width: 100,
    fixed: false
  },
  {
    dataField: 'InvoiceDate',
    caption: 'Date',
    allowResizing: true,
    minWidth: 150,
    width: 150,
    fixed: false
  },
  {
    dataField: 'CustomerAccount',
    caption: 'Customer',
    allowResizing: true,
    minWidth: 100,
    width: 100,
    fixed: false
  },
  {
    dataField: 'CustomerPO',
    caption: 'Customer P/O',
    allowResizing: true,
    minWidth: 120,
    width: 120,
    fixed: false
  },
  {
    dataField: 'Type',
    caption: 'Type',
    allowResizing: true,
    minWidth: 100,
    width: 100,
    fixed: false
  },
  {
    dataField: 'CustomerName',
    caption: 'Customer Name',
    allowResizing: true,
    minWidth: 100,
    width: 100,
    fixed: false
  },
];

export const salesInvoiceEnquiryLookupConstants: ICustomLookupOptions = {
  columns: LOOKUP_COLUMNS,
  dialogStyle: DEFAULT_SEARCH_SCREEN_DIALOG_STYLE,
  hideColumnHeaders: false,
  disableGridColumnLines: false,
  dataPrefix: 'Details',
  tabbedLookup: {
    isTabbedLookup: true,
  }
};
